import { SectionHeading } from '@/components/ui/SectionHeading';
import { AnimateIn } from '@/components/ui/AnimateIn';
import { PhoneMockup } from '@/components/ui/PhoneMockup';
import { Button } from '@/components/ui/Button';
import { MERCHANT_FEATURES } from '@/data/content';
import { scrollToId } from '@/lib/utils';

function ChartIcon() {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="flex-shrink-0 text-brand-500"
    >
      <polyline points="22 7 13.5 15.5 8.5 10.5 2 17" />
      <polyline points="16 7 22 7 22 13" />
    </svg>
  );
}

export function ForMerchants() {
  return (
    <section id="merchants" className="bg-gray-50 py-24">
      <div className="container mx-auto px-6">
        <SectionHeading
          eyebrow="For Merchants"
          title="Turn quiet hours into peak traffic"
          className="mb-16 lg:hidden"
        />

        <div className="flex flex-col-reverse items-center gap-16 lg:flex-row">
          {/* Left - Phone Mockup */}
          <div className="flex-shrink-0">
            <PhoneMockup>
              <div className="p-4 pt-10">
                {/* Header */}
                <div className="flex items-center justify-between px-1">
                  <span className="text-sm font-bold text-white">
                    Active Deals
                  </span>
                  <span className="rounded-full bg-brand-500/20 px-2 py-0.5 text-xs font-medium text-brand-400">
                    3 live
                  </span>
                </div>

                {/* Mini stats */}
                <div className="mt-4 grid grid-cols-3 gap-2">
                  <div className="rounded-lg bg-white/10 p-2 text-center">
                    <p className="text-lg font-bold text-white">247</p>
                    <p className="text-[10px] text-gray-400">Views</p>
                  </div>
                  <div className="rounded-lg bg-white/10 p-2 text-center">
                    <p className="text-lg font-bold text-green-400">58</p>
                    <p className="text-[10px] text-gray-400">Claims</p>
                  </div>
                  <div className="rounded-lg bg-white/10 p-2 text-center">
                    <p className="text-lg font-bold text-brand-400">23%</p>
                    <p className="text-[10px] text-gray-400">Conv.</p>
                  </div>
                </div>

                {/* Deal list */}
                <div className="mt-4 space-y-2">
                  <div className="rounded-lg bg-white/10 p-3">
                    <div className="flex items-center justify-between">
                      <span className="text-xs font-semibold text-white">
                        Flash Coffee Deal
                      </span>
                      <span className="h-2 w-2 animate-pulse rounded-full bg-green-400" />
                    </div>
                    <div className="mt-1 flex items-center justify-between text-[10px] text-gray-400">
                      <span>50% → 10% decay</span>
                      <span>18/25 claimed</span>
                    </div>
                  </div>
                  <div className="rounded-lg bg-white/10 p-3">
                    <div className="flex items-center justify-between">
                      <span className="text-xs font-semibold text-white">
                        Lunch Special
                      </span>
                      <span className="h-2 w-2 animate-pulse rounded-full bg-yellow-400" />
                    </div>
                    <div className="mt-1 flex items-center justify-between text-[10px] text-gray-400">
                      <span>30% → 10% decay</span>
                      <span>6/15 claimed</span>
                    </div>
                  </div>
                </div>

                <div className="h-6" />
              </div>
            </PhoneMockup>
          </div>

          {/* Right - Features */}
          <div className="flex-1">
            <SectionHeading
              eyebrow="For Merchants"
              title="Turn quiet hours into peak traffic"
              align="left"
              className="mb-10 hidden lg:flex"
            />
            <ul className="space-y-6">
              {MERCHANT_FEATURES.map((feature, index) => (
                <AnimateIn key={feature.title} delay={index * 100}>
                  <li className="flex gap-4">
                    <ChartIcon />
                    <div>
                      <h3 className="font-semibold text-gray-900">
                        {feature.title}
                      </h3>
                      <p className="mt-1 text-sm text-gray-600">
                        {feature.description}
                      </p>
                    </div>
                  </li>
                </AnimateIn>
              ))}
            </ul>
            <div className="mt-10">
              <Button size="lg" onClick={() => scrollToId('waitlist')}>
                Register Merchant Interest
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
